//#region import
import React, { useEffect, useState } from 'react'
import { Box, Chip, Grid, IconButton, Popover, Tooltip, Typography } from '@mui/material';
import { FnAxios, FnDialog, I18n, RouterDOM } from 'utilities/utilities';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { BtnAddOnTable, BtnEditOnTable, BtnPreviewOnTable, BtnViewImageOnTable, BtnViewOnTable } from 'components/Button/ButtonTable';
import { FilterFieldInterface } from 'components/DataGrid/DataGridProps';
import ChangeOrder from 'components/System/ChangeOrder';
import { EnumStatus, I18NextNs } from 'enum/enum';
import FilePopup from 'components/Input/UploadFile/components/PopUp/FilePopup';
import InfoIcon from '@mui/icons-material/Info';
import { useLocation } from 'react-router';
import { GetMenuPermission } from 'utilities/SystemFunction';
//#endregion

const BannerList = () => {
    const Router = RouterDOM();
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();
    const [lstOrder, setLstOrder] = useState<any>([]);
    const [loadingTable, setLoadingTable] = useState(false);
    const [IsopenPopUp, setIsopenPopUp] = useState<any>(false);
    const [fileImage, setFileImage] = useState();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [sUpdateName, setUpdateName] = useState(null);
    // sort oser รอบ 3 ติดบักลองแก้ไขแล้วแต่ยังติดหลังบ้านเดี๋ยวจะแก้เพิ่มเติม
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "",
        sSortDirection: ""
    });

    const [isPermission, setPermission] = useState<boolean>(false); // Permission

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const Delete = (e) => {
        DialogFn.Submit(I18n.SetText("deletemsg", I18NextNs.translation), async () => {
            DialogFn.BlockUI();
            setLoadingTable(true);
            AxiosFn.Post(
                "BannerControllers/Delete",
                { lstBannerDelete: e },
                (res) => {
                    getTableBanner(dataRow)
                    DialogFn.Success("ลบสำเร็จ");
                    DialogFn.UnBlockUI();

                },
                (err) => {
                    if (!err.response) {
                        DialogFn.Warning(err.Message);
                    }
                    DialogFn.UnBlockUI();
                }
            );
        });
    };

    const handleViewInfo = (e) => {
        setUpdateName(e.sUpdateName);//sUpdateName
    }
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);

    const dataColumn: any = [
        {
            renderHeader: (item) => (
                <>
                    <BtnAddOnTable
                        onClick={() => Router.GoToPage(`/BannerForm`)} id={"Add"} IsDisabled={!isPermission} />
                </>
            ),
            field: "ปุ่ม (เพิ่ม/แก้ไข)",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 80,
            getActions: (item) => {
                return [
                    <Box
                        key={item.row.sID}
                        sx={{ display: "flex", width: "100%", alignItems: "flex-start" }}
                    >
                        {isPermission ? (
                            <BtnEditOnTable
                                txt="แก้ไข"
                                onClick={() => goToEdit(item.row.sID)}
                                id={'btnedittb'}
                            />
                        ) : (
                            <BtnViewOnTable
                                key={item.row.sID}
                                id="btnView"                     
                                onClick={() => goToEdit(item.row.sID)}
                            />
                        )}
                        {item.row.BannerFile && (
                            <BtnViewImageOnTable
                                txt="ดูภาพ"
                                onClick={() => {
                                    OpenPopUp(item.row);
                                }}
                                id={'btnviewtb'}
                            />
                        )}
                    </Box>,
                ];
            },

        },
        {
            field: "nNo",
            headerName: "ลำดับ",
            headerAlign: "center",
            editable: false,
            resizable: false,
            align: "center",
            sortable: true,
            width: 100,
            renderCell: (item) => {
                return (
                    <ChangeOrder
                        item={item}
                        onChangeOrder={onChangeOrder}
                        optOrder={lstOrder}
                        IsView={false}
                        IsDisabled={!isPermission}
                    />
                );
            },
        },
        {
            field: "sBannerName",
            headerName: "ชื่อแบนเนอร์",
            headerAlign: "center",
            align: "Left",
            sortable: true,
            flex: 2,
            width: 220,
        },
        {
            field: "sStartDate",
            headerName: "วันที่เริ่มต้นแสดงผล",
            headerAlign: "center",
            align: "center",
            sortable: true,
            // flex: 1,
            width: 120,
        },
        {
            field: "sEndDate",
            headerName: "วันที่สิ้นสุดแสดงผล",
            headerAlign: "center",
            align: "center",
            sortable: true,
            // flex: 1,
            width: 120,
        },
        {
            field: "sUpdateDate",
            headerName: "แก้ไขล่าสุด",
            headerAlign: "center",
            align: "center",
            sortable: true,
            // flex: 1,
            width: 200,
            renderCell: (item) => {
                return (
                    <>
                        <Grid sx={{ mr: "4px" }}>
                            {item.row.sUpdateDate}
                        </Grid>
                        <IconButton size="small"
                            onClick={(e) => { handleClick(e); handleViewInfo(item.row); }}
                        >
                            <InfoIcon
                                style={{ color: "#6e130d", cursor: "pointer" }}
                            />
                        </IconButton>
                    </>
                )
            }
        },
        {
            field: "isActive",
            headerName: "สถานะ",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 100,
            renderCell: (item) => {
                return (
                    <>
                        {EnumStatus.Active == item.row.nStatus &&
                            <Tooltip title={item.row.sStatus}>
                                <Chip
                                    size="medium"
                                    label={item.row.sStatus}
                                    style={{
                                        color: "rgb(22 187 68)",
                                        backgroundColor: "rgb(231 255 237)",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>
                        }
                        {EnumStatus.isActive == item.row.nStatus &&
                            <Tooltip title={item.row.sStatus}>
                                <Chip
                                    size="medium"
                                    label={item.row.sStatus}
                                    style={{
                                        color: "#f1416c",
                                        backgroundColor: "#fff5f8",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>

                        }


                    </>
                )
            }
        },

    ];

    const getTableBanner = (p: PaginationInterface) => {
        setLoadingTable(true);
        let Param = {
            ...p,
            // nDataLength: p.nDataLength,
            // nPageSize: p.nPageSize,
            // nPageIndex: p.nPageIndex,
            // sSortExpression: p.sSortExpression ?? "",
            // sSortDirection: p.sSortDirection ?? "",
            // sBanner:p.
            // isASC: p.isASC,
            // isDESC: p.isDESC,
        };
        AxiosFn.Post(`BannerControllers/GetTableList`, Param, (result) => {
            setLoadingTable(false);
            setDataRow({
                ...p,
                arrRows: [...result.lstData],
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });
            if (result.nOrder !== null) {
                let arrOpt = [];
                for (let i = 1; i <= result.nOrder; i++) {
                    arrOpt.push({ label: `${i}`, value: `${i}` });
                }
                setLstOrder([...arrOpt]);
            }

        });
    };


    //#region onChangeOrder
    const onChangeOrder = async (sID, nOrder) => {
        let param = {
            sID: sID,
            NewOrder: nOrder,
            Table: "TbBanner",
            Column: "nBannerID",
            TypeColumn: "",
            TypeID: 0,
            sLocation: location.pathname,
        };
        AxiosFn.Post("BannerControllers/OnChangeOrder", param, (res) => {
            getTableBanner(dataRow);
        }, (err) => {
            if (!err.response) {
                DialogFn.Warning(err.Message);
            }
        });
    };

    //#endregion

    useEffect(() => {
        getTableBanner(dataRow);
        // getFormInitial();
    }, []);

    const goToEdit = (sID: string) => {
        Router.GoToPage(`/BannerForm?sID=${encodeURI(sID)}`);
    };

    const OpenPopUp = (item) => {
        setFileImage(item.BannerFile[0]);
        setIsopenPopUp(true);
    };

    const ClosePopUp = () => {
        setIsopenPopUp(false);
    };



    //Filter Search
    const filter: FilterFieldInterface[] = [
        { sTypeFilterMode: "input", sLabel: "ชื่อแบนเนอร์", sFieldName: "sBanner", nGridLG: 4, nGridMD: 4, nGridSM: 6, nGridXS: 12 },
        { sTypeFilterMode: "date", sLabel: "วันที่แสดงผล (เริ่ม)", sFieldName: "dStart", nGridLG: 4, nGridMD: 4, nGridSM: 6, nGridXS: 12 },
        { sTypeFilterMode: "date", sLabel: "วันที่แสดงผล (สิ้นสุด)", sFieldName: "dEnd", nGridLG: 4, nGridMD: 4, nGridSM: 6, nGridXS: 12 },
        {
            sTypeFilterMode: "select", sLabel: "สถานะ", sFieldName: "sStatus",
            optionSelect: [
                {

                    label: "ใช้งาน",
                    value: "1"
                },
                {

                    label: "ไม่ใช้งาน",
                    value: "0"
                },

            ],
            nGridLG: 2, nGridMD: 2, nGridSM: 6, nGridXS: 12
        },
    ];
    return (
        <Grid item xs={12} sx={{ mt: 1 }}>
            {IsopenPopUp && (
                <FilePopup
                    file={fileImage}
                    isGallery={false}
                    IsopenPopUp={IsopenPopUp}
                    ClosePopUp={ClosePopUp}
                />
            )}
            <DataGrid
                sTableID='tb1'
                columns={dataColumn}
                rows={dataRow}
                modeFilter={1}
                onLoadData={getTableBanner}
                onDelete={Delete}
                isLoading={loadingTable}
                isHiddenToolHead={false}
                filterField={filter}
                isShowCheckBox={isPermission}
            />
            {/* pop over */}
            <Popover
                id={`sUpdateName`}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Typography sx={{ p: 2 }}>{sUpdateName}</Typography>
            </Popover>
        </Grid>


    )
}
export default BannerList;
